<template>
	<div id="subjects_page_wrapper">
		<!-- desktop search input & create button -->
		<div class="d-flex justify-content-end">
			<div class="bb-subjects-table-search d-flex align-items-center">
				<i class="flaticon-search"></i>
				<input type="text" :placeholder="$t('subjects.searchInput.placeholder')" v-model="searchTerm" />
			</div>
			<button class="bb-new-subject-btn" @click="createSubject">
				{{ $t('subjects.createSubjectBtn') }}
			</button>
		</div>
		<!-- desktop data table -->
		<v-data-table :headers="tableHeaders" :items="displaySubjects" hide-default-footer :items-per-page="perPageValue" ref="subjectsTable" class="bb-table subjects-table">
			<template v-slot:item="{ item }">
				<tr>
					<td class="text-left name-column">
						{{ item.client?.full_name }}
					</td>
					<td class="text-left type-column">
						{{ item.type }}
					</td>
					<td class="text-left">
						{{ item.courtName }}
					</td>
					<td class="text-left">
						{{ item.internalSubjectNumber }}
					</td>
					<td class="text-left">
						{{ item.courtCaseNumber }}
					</td>
					<!-- edit & delete button -->
					<td class="text-right edit-cell">
						<div class="table-action-buttons">
							<button class="table-action-button" @click="showClient(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user">
									<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
									<circle cx="12" cy="7" r="4"></circle>
								</svg>
							</button>
							<button class="table-action-button" @click="openEditForm(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit">
									<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
									<path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
								</svg>
							</button>
							<button class="table-action-button" @click="deleteSubject(item)">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
									<polyline points="3 6 5 6 21 6"></polyline>
									<path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
									<line x1="10" y1="11" x2="10" y2="17"></line>
									<line x1="14" y1="11" x2="14" y2="17"></line>
								</svg>
							</button>
						</div>
					</td>
				</tr>
			</template>
		</v-data-table>
		<!-- mobile header -->
		<div class="bb-mobile-header">
			<div class="bb-mobile-header-left">
				<button class="mobile-sidebar-btn" @click="openMobileAside()">
					<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-menu">
						<line x1="3" y1="12" x2="21" y2="12"></line>
						<line x1="3" y1="6" x2="21" y2="6"></line>
						<line x1="3" y1="18" x2="21" y2="18"></line>
					</svg>
				</button>
			</div>
			<h1>{{ $t('subjects.title') }}</h1>
			<div class="bb-mobile-header-right"></div>
		</div>
		<!-- mobile wrapper -->
		<div id="mobile_subjects_wrapper">
			<!-- mobile search -->
			<div class="bb-input-group search-input">
				<i class="fas fa-search"></i>
				<input type="text" v-model="searchTerm" :placeholder="$t('subjects.mobileSearchInput.placeholder')" />
				<button class="bb-badge badge-rounded" v-if="searchTerm" @click="searchTerm = ''">
					<i class="ki ki-close icon-md"></i>
				</button>
			</div>
			<!-- mobile subjects table -->
			<div class="subjects-list">
				<div class="subject-item" v-for="subject in displaySubjects" :key="subject.id" @click="showMobileActions(subject)">
					<div class="d-flex justify-content-start align-items-center">
						<div class="bb-badge badge-sm badge-rounded" style="flex: 0 0 auto">
						</div>
						<div class="subject-details">
							<span>{{ subject.client?.full_name }}</span>
							<small>{{ subject.type }}</small>
							<small>{{ $t('subjects.table.columns.internalSubjectNumber') }} - {{ subject.internalSubjectNumber }}</small>
						</div>
					</div>
					<i class="la la-angle-right"></i>
				</div>
			</div>
			<!-- mobile actions menu -->
			<div id="mobile_actions_container" class="mobile-actions-container" v-show="mobileActionsVisible" v-click-outside="handleMobileActionsOutsideClick">
				<div class="mobile-actions">
					<button class="mobile-action-btn">
						{{ $t("clients.mobileButtons.showProfile") }}
					</button>
					<button class="mobile-action-btn" @click="openEditForm(mobileSelectedSubject); hideMobileActions();">
						{{ $t("clients.mobileButtons.editBtn") }}
					</button>
					<button class="mobile-action-btn danger" @click="deleteSubject(mobileSelectedSubject); hideMobileActions();">
						{{ $t("clients.mobileButtons.deleteBtn") }}
					</button>
				</div>
				<button class="mobile-action-btn" @click="hideMobileActions()">
					{{ $t("clients.mobileButtons.closeBtn") }}
				</button>
			</div>
			<!-- mobile add new subject btn -->
			<button class="mobile-new-subject-btn" @click="createSubject">
				<i class="la la-plus"></i>
			</button>
		</div>
		<!-- Pagination -->
		<div class="bb-table-footer subjects-table-footer">
			<v-pagination class="bb-pagination" @input="paginatePage" v-model="subjectsMeta.current_page" :length="subjectsMeta.last_page" :total-visible="5"></v-pagination>
			<div class="d-flex justufy-content-between align-items-center">
				<BBSelect class="bb-pagination-per-page-select" :options="perPageOptions" v-model="perPageValue" />
				<span class="bb-table-pagination-text">
					{{ $t('subjects.table.pagination.show') }}
					{{ subjectsMeta.from }} - {{ subjectsMeta.to }}
					{{ $t('subjects.table.pagination.of') }}
					{{ subjectsMeta.total }}
				</span>
			</div>
		</div>
		<SubjectFormModal ref="subjectFormModal" />
	</div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import { GET_SUBJECTS } from '@/core/services/store/subjects.module';
import { mapGetters } from 'vuex';
import { EventBus } from '@/core/services/event-bus.js';
import _ from 'lodash';
// import BBDropdown from '@/view/content/BBDropdown.vue';
import BBSelect from '@/view/content/BBForm/BBSelect.vue';
import SubjectFormModal from '@/view/layout/extras/modal/SubjectFormModal.vue';
import subjectFormModalMixin from '@/core/mixins/subjectFormModalMixin.js';
import mobileAsideMixin from '@/core/mixins/mobileAsideMixin.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default {
	name: 'Subjects',
	components: { BBSelect, SubjectFormModal },
	mixins: [subjectFormModalMixin, mobileAsideMixin],
	data() {
		return {
			searchTerm: '',
			tableHeaders: [
				{
					text: this.$t('subjects.table.columns.client'),
					value: 'client',
					align: 'left',
					sortable: false,
				},
				{
					text: this.$t('subjects.table.columns.type'),
					value: 'type',
					align: 'left',
					sortable: false,
				},
				{
					text: this.$t('subjects.table.columns.courtName'),
					value: 'courtName',
					align: 'left',
					sortable: false,
				},
				{
					text: this.$t('subjects.table.columns.internalSubjectNumber'),
					value: 'internalSubjectNumber',
					align: 'left',
					sortable: false,
				},
				{
					text: this.$t('subjects.table.columns.courtCaseNumber'),
					value: 'courtCaseNumber',
					align: 'left',
					sortable: false,
				},

				{
					text: '',
					value: 'id',
					align: 'right',
					sortable: false,
				},
			],
			perPageOptions: [
					{ text: '10', value: 10 },
					{ text: '20', value: 20 },
					{ text: '50', value: 50 },
			],
			perPageValue: 10,
			mobileActionsVisible: false,
			mobileSelectedSubject: null,
		};
	},
	methods: {
		/**
		 *	Method to call pagination
		 *  @param {integer} pageNumber
		 * 	@return {void}
		 */
		paginatePage(pageNumber) {
			this.$store.dispatch(GET_SUBJECTS, {
				pageNumber: pageNumber,
				perPage: this.perPageValue,
				search: this.searchTerm,
			});
		},

		/**
		 * Delete the subject
		 * @param {Object} subject
		 * @return {void}
		 */
		deleteSubject(subject) {
			EventBus.$emit('deletingSubject', {
				subject: subject,
				successCallback: function () {
					this.$store.dispatch(GET_SUBJECTS, { pageNumber: 1});
				},
			});
		},

		/**
		 * Handle table row click
		 * @param {Number} subjectId
		 * @return {void}
		 */
		showSubject(subjectId) {
			this.$router.push({ name: 'subject', params: { id: subjectId } });
		},

		/**
		 * Open edit form modal for appropriate subject
		 *
		 * @param {Object} subject
		 * @return {void}
		 */
		openEditForm(subject) {
			this.editSubject(subject);
		},

		/**
		 * Show mobile service actions
		 * @param {Object} subject
		 * @return {void}
		 */
		showMobileActions(subject) {
			this.mobileSelectedSubject = subject;
			this.mobileActionsVisible = true;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('#mobile_actions_container');
			disableBodyScroll(targetElement);
		},

		/**
		 * Hide mobile actions
		 * @return {void}
		 */
		hideMobileActions() {
			this.mobileSelectedSubject = null;
			this.mobileActionsVisible = false;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('#mobile_actions_container');
			enableBodyScroll(targetElement);
		},

		/**
		 * Handle mobile actions outside click
		 * @param {Object} event
		 * @return {void}
		 */
		handleMobileActionsOutsideClick(event) {
			if (event.target.classList.contains('offcanvas-overlay') && this.mobileActionsVisible) {
				this.hideMobileActions();
			}
		},
	},
	mounted() {
		// Dispatch store SET_BREADCRUMB action to set page title
		this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t('subjects.title') }]);
		// Dispatch store GET_SUBJECTS action to get subjects from api
		this.$store.dispatch(GET_SUBJECTS, { pageNumber: 1});
	},
	watch: {
		/**
		 * Watch per page value changes and dispatch actions
		 * @param {Number} perPage
		 * @return {void}
		 */
		perPageValue: function () {
			this.$store.dispatch(GET_SUBJECTS, {
				pageNumber: 1,
				perPage: this.perPageValue,
				search: this.searchTerm
			});
		},

		/**
		 * Watch for change on searchTerm and dispatch actions to fetch query results
		 * @return {void}
		 */
		searchTerm: _.throttle(function(){
			this.$store.dispatch(GET_SUBJECTS, {
				perPage: this.perPageValue,
				search: this.searchTerm
			});
		}, 1000)
	},
	computed: {
		...mapGetters(['allSubjects', 'subjectsMeta']),

		/**
		 * Return array of subjects to display
		 * @return {Array}
		 */
		displaySubjects() {
			if (this.allSubjects === 0) {
				return [];
			}
			return this.allSubjects
		},
	},
};
</script>

<style lang="scss">
@import '@/assets/sass/bb-styles/pages/subjects.scss';
</style>
